import { ShippingManifestDestinationCorrectionBoxValue } from "./shipping-manifest-destination-correction-form.value";

export default function isCorrectionBoxComplete(
  box?: ShippingManifestDestinationCorrectionBoxValue
): boolean {
  if (!box) {
    return false;
  }

  const { boxNumber, length, width, height, weight } = box;

  return (
    typeof boxNumber === "number" &&
    Number.isInteger(boxNumber) &&
    boxNumber >= 0 &&
    [length, width, height].every(
      (value) =>
        typeof value === "number" && Number.isInteger(value) && value > 0
    ) &&
    typeof weight === "number" &&
    !Number.isNaN(weight) &&
    weight >= 0
  );
}
